import { Link } from "@tanstack/react-router";

type Tile = {
  title: string;
  subtitle: string;
  image: string;
  to: "/collections/$collection";
  params: { collection: string };
};

const tiles: Tile[] = [
  {
    title: "Hats",
    subtitle: "",
    image: "https://cdn.shopify.com/s/files/1/0808/1332/6620/files/681ECC54-8A64-4C7E-B2DB-2A741B1C69A6.png?v=1765165220",
    to: "/collections/$collection",
    params: { collection: "all-hats" },
  },
  {
    title: "Tops",
    subtitle: "",
    image: "https://cdn.shopify.com/s/files/1/0808/1332/6620/files/02E654D6-940D-48A1-857D-CC68FBD02DF3.jpg?v=1725217582",
    to: "/collections/$collection",
    params: { collection: "tops" },
  },
];

export function CategoryTiles() {
  return (
    <section className="bg-[#F5EFE2] py-20">
      <div className="mx-auto max-w-[1400px] px-6">
        <div className="mb-10 text-center">
          <p className="font-ui text-[11px] font-bold uppercase tracking-[0.3em] text-saddle">Shop by Category</p>
          <h2 className="mt-2 font-heading text-4xl font-bold uppercase tracking-tight text-[#2A1510] md:text-5xl">Shop the Collection</h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {tiles.map((t) => (
            <div key={t.title} className="flex flex-col">
              <Link
                to={t.to}
                params={t.params}
                className="group relative flex aspect-[16/10] flex-col justify-end overflow-hidden rounded-sm bg-[#412019]"
              >
                <img
                  src={t.image}
                  alt={t.title === "Hats" ? "Coyote Creek mesh back and structured hats collection" : "Coyote Creek premium tees and tops collection"}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#412019]/85 via-[#412019]/30 to-transparent" />
                <div className="relative z-10 p-8">
                  <h3 className="font-heading text-3xl font-bold uppercase text-[#F5EFE2] md:text-5xl">{t.title}</h3>
                  {t.subtitle && <p className="mt-1 font-body text-sm text-[#F5EFE2]/80">{t.subtitle}</p>}
                </div>
              </Link>
              <div className="mt-4 flex justify-center">
                <Link to={t.to} params={t.params} className="btn-cc-accent">
                  Shop Now →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
